module.exports = __webpack_public_path__ + "img/3-5.d1b52c30.png";